// Navigation links for the navbar
export const navLinks = [
    { name: "Home", path: "/" },
    { name: "Projects", path: "/projects" },
    { name: "Tools", path: "/tools", badge: "FREE" },
    { name: "Collab", path: "/collab" },
    { name: "Academy", path: "/academy" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
];

// Services offered
export const services = [
    {
        title: "Brand Identity & Visual Design",
        description:
            "Creating memorable brand identities that capture your essence and communicate your values effectively through comprehensive creative solutions.",
        icon: "🎨",
        details: {
            overview: "Complete brand identity solutions including logo design, color palettes, typography, and comprehensive brand guidelines for businesses of all sizes.",
            features: [
                "Logo Design & Brand Mark Development",
                "Color Palette & Typography Systems",
                "Brand Guidelines & Style Guides",
                "Visual Identity Standards",
                "Brand Collateral Design",
                "Rebranding & Brand Refresh"
            ],
            tags: "LOGO • BRAND GUIDELINES • STYLE GUIDES • VISUAL IDENTITY"
        }
    },
    {
        title: "UI/UX Design & User Experience",
        description:
            "Designing intuitive interfaces that prioritize user needs and create seamless digital experiences with focus on usability and engagement.",
        icon: "💻",
        details: {
            overview: "User-centered solutions for web and mobile applications, focusing on intuitive user experiences and modern interfaces that drive engagement.",
            features: [
                "User Research & Analysis",
                "Wireframing & Prototyping",
                "Interface Design (Web & Mobile)",
                "User Testing & Iteration",
                "Design Systems & Component Libraries",
                "Accessibility & Inclusive Design"
            ],
            tags: "UX RESEARCH • WIREFRAMING • PROTOTYPING • INTERFACE DESIGN"
        }
    },
    {
        title: "Printing & Packaging Production",
        description:
            "Delivering high-quality print materials and packaging solutions that make a lasting physical impression with professional execution.",
        icon: "📦",
        details: {
            overview: "Professional printing and packaging services including business cards, brochures, product packaging, and large format printing for maximum visual impact.",
            features: [
                "Business Cards & Stationery",
                "Brochures & Marketing Materials",
                "Product Packaging Design",
                "Large Format Printing",
                "Promotional Materials",
                "Print-Ready File Preparation",
                "Material & Finishing Selection"
            ],
            tags: "BUSINESS CARDS • PACKAGING • MARKETING MATERIALS • PRINT PRODUCTION"
        }
    },
    {
        title: "Digital Marketing & Growth Strategy",
        description:
            "Supporting your business growth with strategic creative solutions and performance-driven marketing approaches that deliver measurable results.",
        icon: "📣",
        details: {
            overview: "Performance-driven campaigns including social media management, SEO optimization, ad creatives, analytics, and comprehensive brand strategy for business growth.",
            features: [
                "Social Media Management & Strategy",
                "SEO Optimization & Content Marketing",
                "Ad Campaign Design & Management",
                "Analytics & Performance Tracking",
                "Brand Strategy & Positioning",
                "Growth Marketing Tactics",
                "Conversion Rate Optimization"
            ],
            tags: "BRAND STRATEGY • MARKETING • ANALYTICS • SEO • SOCIAL MEDIA"
        }
    },
    {
        title: "Training & Courses",
        description:
            "Professional training programs and courses in design, branding, and digital marketing to empower individuals and teams with industry-standard skills.",
        icon: "📚",
        details: {
            overview: "Comprehensive training programs designed to upskill individuals and teams in modern design and marketing practices with hands-on learning.",
            features: [
                "Design Fundamentals & Tools",
                "Digital Marketing Courses",
                "UI/UX Design Training",
                "Brand Strategy Workshops",
                "One-on-One Mentorship",
                "Team Training Programs",
                "Certification Preparation"
            ],
            tags: "TRAINING • COURSES • WORKSHOPS • MENTORSHIP • SKILL DEVELOPMENT"
        }
    },
    {
        title: "Web Development & Software Solutions",
        description:
            "Building professional websites and web-based software solutions with modern technologies, ensuring scalability, maintainability, and robust security practices.",
        icon: "🌐",
        details: {
            overview: "Complete web solutions including responsive frontend design, backend development, database architecture, and full-stack implementation with modern technologies and best practices.",
            features: [
                "Responsive Website Development",
                "Web-Based Software Applications",
                "Frontend (React, Next.js, Vue)",
                "Backend (Node.js, Python, PHP)",
                "Database Architecture & Optimization",
                "Security & Maintainability Focus",
                "API Development & Integration",
                "Progressive Web Apps (PWA)"
            ],
            tags: "WEB APPS • FULL-STACK • MAINTAINABILITY • SECURITY • FRONTEND • BACKEND"
        }
    },
    {
        title: "Cloud & Deployment Services",
        description:
            "Professional cloud deployment and hosting services for websites and web-based applications, with ongoing maintenance, security updates, and performance optimization.",
        icon: "☁️",
        details: {
            overview: "Comprehensive cloud infrastructure management, deployment, and hosting services ensuring your websites and applications run smoothly with maximum uptime and security.",
            features: [
                "Cloud Hosting & Infrastructure Setup",
                "Automated Deployment Pipelines",
                "Server Configuration & Management",
                "Performance Monitoring & Optimization",
                "Security Updates & Patches",
                "Backup & Disaster Recovery",
                "24/7 Support & Maintenance",
                "Scalability & Load Balancing"
            ],
            tags: "CLOUD HOSTING • DEPLOYMENT • MONITORING • SUPPORT • DEVOPS"
        }
    },
];